// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.rowIndex_kWYka {
  display : flex;
  flex-direction: column;
  height : 100%;
}

.rowSpacer_P54EW { 
  flex-grow: 0;
  flex-shrink: 0;
}

.rowContent_u7ifm {
  overflow-x : auto;
  overflow-y : hidden;
  
  flex-grow: 1;
  flex-shrink: 1;
}

.rowContent_u7ifm.scroll_QB50t {
  overflow-y: scroll;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
}
.rowContent_u7ifm.scroll_QB50t::-webkit-scrollbar { /* WebKit */
  width: 0;
  height: 0;
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/ui-linear-view-elements/lib/RowHeaderView.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;;EAEnB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,GAAG,0BAA0B;AACvD;AACA,oDAAwC,WAAW;EACjD,QAAQ;EACR,SAAS;AACX","sourcesContent":["\n.rowIndex {\n  display : flex;\n  flex-direction: column;\n  height : 100%;\n}\n\n.rowSpacer { \n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.rowContent {\n  overflow-x : auto;\n  overflow-y : hidden;\n  \n  flex-grow: 1;\n  flex-shrink: 1;\n}\n\n.rowContent.scroll {\n  overflow-y: scroll;\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none;  /* Internet Explorer 10+ */\n}\n.rowContent.scroll::-webkit-scrollbar { /* WebKit */\n  width: 0;\n  height: 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rowIndex": `rowIndex_kWYka`,
	"rowSpacer": `rowSpacer_P54EW`,
	"rowContent": `rowContent_u7ifm`,
	"scroll": `scroll_QB50t`
};
export default ___CSS_LOADER_EXPORT___;
